import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Transition } from 'myt-react-snippets';
import ModalBody from './ModalBody';
import ModalTitle from './ModalTitle';
import ModalFooter from './ModalFooter';

const ModalProps = {
	show: PropTypes.bool.isRequired,
	size: PropTypes.oneOf(['sm', 'lg', 'xl']),
	onHide: PropTypes.func,
	children: PropTypes.arrayOf(PropTypes.element),
};

const Modal = ({ show, size, onHide, children }) => { 
	return ReactDOM.createPortal(
		<Transition
			in={show}
			timing={800}
			suffix={{ enter: 'show', exit: '' }}
			onEnter={(target) => {
				target.classList.add('transition');
				document.body.classList.add('n-modal-shown')
			}}
			onEntered={(target) => {
				target.classList.remove('transition');
			}}
			onExit={(target) => {
				target.classList.add('transition');
			}}
			onExited={(target) => {
				target.classList.remove('transition');
				document.body.classList.remove('n-modal-shown')
			}}
			allowRef>
			<div 
				className='n-modal d-block'
				onClick={(e) => show && e.target.matches('.n-modal') && onHide && onHide(e)}>
				<div className={`n-modal-dialog${size ? ` n-modal-${size}` : ''}`}>
					<div className='n-modal-content'>{children}</div>
				</div>
			</div>
		</Transition>,
		modalCorner
	);
};

Modal.propTypes = ModalProps;
Modal.Title = ModalTitle;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

const modalCorner = document.createElement('div');

document.body.appendChild(modalCorner);

export default Modal;
